import {AsistenciaRP, AsistenciaR} from "../../assets/image/";
import React from "react";
import {
    Card,
    CardActionArea,
    CardMedia,
    CardContent,
    Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { authSelector } from "../../store/auth/auth";
const CardOption = ({ImageIcon,title,onClick}: {ImageIcon:  typeof AsistenciaRP ,title: string,onClick:()=>void}) => {
    return (
        <Card sx={{ maxWidth: 405 }} onClick={onClick}>
            <CardActionArea className="contInfo">
                <img src={ImageIcon}/>
                {/*<ImageIcon ></ImageIcon>*/}
                {/*<CardMedia component="img" height="140" image={image} alt={title} />*/}
                <CardContent>
                    <Typography gutterBottom variant="h5" component="p">
                        {title}
                    </Typography>
                </CardContent>
            </CardActionArea>
        </Card>
    );
};

const Main = () => {
    const navigate = useNavigate();
    const { user } = useSelector(authSelector);
    const arrayTaxiPlan = JSON.parse(process.env.REACT_APP_ID_TAXIPLAN ?? "");

    const arrayCajaGeneral = JSON.parse(
        process.env.REACT_APP_ID_CAJA_GENERAL ?? ""
    );
    const arraySaleReport = JSON.parse(
        process.env.REACT_APP_ID_UPLOAD_SALE ?? ""
    );
    const arrayDirectSells = JSON.parse(
        process.env.REACT_APP_ID_VENTAS_DIRECTAS ?? ""
    );

    const hasAccessToUploadReport = [1, 45, 56].some(
        (value) => value === user.id
    );


    return (
        <>
            <div className="cont-cards">
                {
                    hasAccessToUploadReport &&  <CardOption
                        ImageIcon={AsistenciaR}
                        title="Carga del Reporte de Asistencia"
                        onClick={() => navigate("/reports-attendance", { replace: true })}
                    />
                }


                <CardOption
                    ImageIcon={AsistenciaRP}
                    title="Reporte Personalizado"
                    onClick={() => navigate("/reports", { replace: true })}
                />

            </div>
        </>
    );
};

export default Main;
